import React from 'react'
import { connect } from 'react-redux'

class ViewInventoryImage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    return (
      <div className='section' style={{ width: '50vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Inventory Images</h4>
        </div>
        <div>
          {
            this.props.detail.inventory_images.length > 0
            ? this.props.detail.inventory_images.map((item, i) => (
              <div key={i}>
                <label className='control-label'>Image No. { i + 1 }</label>
                <img className='img img-responsive img-border' style={{ width: '100%' }} alt={this.props.detail.inventory_images[i].image_file} title={this.props.detail.inventory_images[i].image_file} src={this.props.detail.inventory_images[i].image_url} />
              </div>
            ))
            : <div>
              <h3>--No Image--</h3>
            </div>
          }
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({})

export default connect(stateToProps, dispatchToProps)(ViewInventoryImage)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/ViewInventoryImage.js